import type { RouteRecordRaw } from "vue-router"
import { useApplicationStore } from "@versatile-credit-apply/sdk"

export const ProgressiveDecisionRoutes: RouteRecordRaw[] = [
  {
    name: "progressive-apply-prequalified",
    path: "prequalified",
    component: () => import("./components/ProgressivePrequalified.vue"),
    meta: {
      next: "../application",
      step: (steps) =>
        steps.includes("applicant") ? "applicant" : "reviewOffer",
    },
  },
  {
    name: "progressive-apply-approved",
    path: "approved",
    component: () => import("./components/ProgressiveApproved.vue"),
  },
  {
    name: "progressive-apply-declined",
    path: "declined",
    component: () => import("./components/ProgressiveDeclined.vue"),
  },
  {
    name: "progressive-apply-pending",
    path: "pending",
    component: () => import("./components/ProgressivePending.vue"),
  },
  {
    name: "progressive-apply-error",
    path: "error",
    component: () => import("./components/ProgressiveError.vue"),
  },
  {
    name: "progressive-apply-nooffer",
    path: "nooffer",
    component: () => import("./components/ProgressiveNoOffer.vue"),
  },
]

export const ProgressiveApplyRoutes: RouteRecordRaw[] = [
  {
    name: "progressive-apply-routes",
    path: "progressive_standard",
    children: [
      {
        name: "progressive-apply-start",
        path: "start/:mode",
        component: () => import("./pages/ProgressiveIntroPage.vue"),
        meta: {
          step: "applicant",
        },
      },
      {
        name: "progressive-terms",
        path: "terms",
        component: () => import("./pages/ProgressiveApplyTermsPage.vue"),
        meta: {
          next: () => {
            const store = useApplicationStore()
            return store.applyMode !== "full" ? "accept-offer" : "submit"
          },
          step: "terms",
        },
      },
      {
        name: "progressive-apply-decisions",
        path: "decision",
        component: () => import("./pages/ProgressiveDecisionPage.vue"),
        meta: {
          preventBack: true,
          step: "decision",
        },
        children: ProgressiveDecisionRoutes,
      },
    ],
  },
]
